import React from 'react';
import { merge, mergeStyles } from './util';
import { defaultAttributes as attributes } from './styles';
export var defaultStylesContext = {
  attributes: attributes,
  merge: merge,
  mergeStyles: mergeStyles,
  styleExtension: {}
};
var NikeStylesContext = React.createContext(defaultStylesContext);
export default NikeStylesContext;